export enum AuthTypes {
  SuperAdministrator = 1,
  Administrator = 2,
  Observator = 3,
  Supervisor = 4,
}
